import { useEffect } from "react";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";
import { useLoginUserLazyQueryHook } from "@/hooks/queries";
import { useTranslation } from "react-i18next";
import { RotatingLinesLoader } from "@/components/shared/loaders";

function TokenLogin() {

  // Hooks
  const { t } = useTranslation();
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const forwardPath = searchParams.get("forward");
  const { loginUser } = useLoginUserLazyQueryHook(forwardPath);

  useEffect(() => {
    // Early exit if no token is present
    if (!token) {
      navigate("/login", { replace: true });
      return;
    }

    try {
      loginUser({ variables: { sessionToken: token } });
    } catch (err) {
      console.log("Error has occurred", err);
      navigate("/login", { replace: true });
    }
  }, [token, navigate, loginUser]);

  return (
    <div className="flex items-center justify-centerw-full h-screen">
      <div className="flex flex-col items-center">
        <p className="text-2xl mb-2">
          {t("tokenlogin.verifying")}
        </p>
        <RotatingLinesLoader
          width={74}
          animationDuration={0.75}
          strokeColor="#42A7DC"
          strokeWidth={8}
          ariaLabel="rotating-lines-loader"
        />
      </div>
    </div>
  );
}

export default TokenLogin;
